(function () {
  'use strict';

  if (window.AcaiDeliverySync) return;

  var STOREFRONT_ENDPOINT = '/api/2026-07/graphql.json';
  var CART_QUERY = [
    'query AcaiCartDeliveryState($cartId: ID!) {',
    '  cart(id: $cartId) {',
    '    id',
    '    checkoutUrl',
    '    deliveryGroups(first: 10) {',
    '      nodes {',
    '        id',
    '        deliveryOptions {',
    '          handle',
    '          title',
    '          estimatedCost { amount currencyCode }',
    '        }',
    '        selectedDeliveryOption {',
    '          handle',
    '          title',
    '          estimatedCost { amount currencyCode }',
    '        }',
    '      }',
    '    }',
    '  }',
    '}'
  ].join('\n');

  var SELECT_MUTATION = [
    'mutation AcaiSelectDeliveryOption(',
    '  $cartId: ID!,',
    '  $selectedDeliveryOptions: [CartSelectedDeliveryOptionInput!]!',
    ') {',
    '  cartSelectedDeliveryOptionsUpdate(',
    '    cartId: $cartId,',
    '    selectedDeliveryOptions: $selectedDeliveryOptions',
    '  ) {',
    '    cart { id checkoutUrl }',
    '    userErrors { field message }',
    '    warnings { code message target }',
    '  }',
    '}'
  ].join('\n');

  var queue = Promise.resolve();

  function delay(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase('de-DE')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function graphql(document, variables) {
    return fetch(STOREFRONT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: document, variables: variables })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Storefront API HTTP ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        if (payload.errors && payload.errors.length) {
          throw new Error(payload.errors.map(function (error) {
            return error.message;
          }).join('; '));
        }
        return payload.data;
      });
  }

  function getActionCart(attempt) {
    attempt = attempt || 0;
    if (
      window.Shopify &&
      window.Shopify.actions &&
      typeof window.Shopify.actions.getCart === 'function'
    ) {
      return Promise.resolve(window.Shopify.actions.getCart()).then(function (result) {
        var cart = result && (result.cart || result);
        if (!cart || !cart.id) throw new Error('Shopify cart ID fehlt.');
        return cart;
      });
    }
    if (attempt >= 40) throw new Error('Shopify Cart Actions sind nicht verfügbar.');
    return delay(100).then(function () { return getActionCart(attempt + 1); });
  }

  function getState(cartId) {
    return graphql(CART_QUERY, { cartId: cartId }).then(function (data) {
      if (!data || !data.cart) throw new Error('Der Warenkorb ist nicht mehr verfügbar.');
      return data.cart;
    });
  }

  function isPickup(option) {
    return normalize(option && option.title).indexOf('selbstabholung freezelog') === 0;
  }

  function isFreeHouse(option) {
    var title = normalize(option && option.title);
    return title.indexOf('versand per tiefkühl-spedition') === 0 ||
      title.indexOf('versand per tiefkuehl-spedition') === 0 ||
      title.indexOf('lieferung frei haus') === 0;
  }

  function isExpress(option) {
    var title = normalize(option && option.title);
    return title.indexOf('express') >= 0 && title.indexOf('probe') >= 0;
  }

  function hasTag(tags, wanted) {
    return (tags || []).some(function (tag) {
      return normalize(tag) === normalize(wanted);
    });
  }

  function findTarget(group, lieferart, tags) {
    var options = (group && group.deliveryOptions) || [];
    var kind = normalize(lieferart);
    var matches;

    if (kind === 'abholung') {
      matches = options.filter(isPickup);
    } else if (kind === 'lieferung frei haus') {
      matches = options.filter(isFreeHouse);
    } else if (kind === 'probelieferung express') {
      matches = options.filter(isExpress);
    } else if (kind === 'versand') {
      if (hasTag(tags, 'versand_70')) {
        matches = options.filter(function (option) {
          return normalize(option.title).indexOf('nahbereich') === 0;
        });
      } else if (hasTag(tags, 'versand_150')) {
        matches = options.filter(function (option) {
          return normalize(option.title).indexOf('palettenversand') === 0;
        });
      } else {
        matches = options.filter(function (option) {
          return !isPickup(option) && !isFreeHouse(option) && !isExpress(option);
        });
      }
    } else {
      throw new Error('Unbekannte Lieferart: ' + lieferart);
    }

    if (matches.length !== 1) {
      throw new Error(
        'Für "' + lieferart + '" wurde keine eindeutige Versandart gefunden (' +
        matches.length + ' Treffer).'
      );
    }
    return matches[0];
  }

  function buildPlan(cart, lieferart, tags) {
    var groups = cart.deliveryGroups && cart.deliveryGroups.nodes;
    if (!groups || !groups.length) {
      throw new Error('Noch keine Versandarten verfügbar.');
    }
    return groups.map(function (group) {
      var option = findTarget(group, lieferart, tags);
      return {
        deliveryGroupId: group.id,
        deliveryOptionHandle: option.handle
      };
    });
  }

  function planIsSelected(cart, plan) {
    var groups = cart.deliveryGroups && cart.deliveryGroups.nodes;
    if (!groups || groups.length !== plan.length) return false;
    return plan.every(function (selection) {
      var group = groups.find(function (candidate) {
        return candidate.id === selection.deliveryGroupId;
      });
      return !!(
        group &&
        group.selectedDeliveryOption &&
        group.selectedDeliveryOption.handle === selection.deliveryOptionHandle
      );
    });
  }

  function selectOnce(lieferart, options) {
    var tags = (options && options.customerTags) || [];
    var cartId;
    var plan;

    return getActionCart()
      .then(function (actionCart) {
        cartId = actionCart.id;
        return getState(cartId);
      })
      .then(function (cart) {
        plan = buildPlan(cart, lieferart, tags);
        if (planIsSelected(cart, plan)) return cart;
        return graphql(SELECT_MUTATION, {
          cartId: cartId,
          selectedDeliveryOptions: plan
        }).then(function (data) {
          var payload = data && data.cartSelectedDeliveryOptionsUpdate;
          var errors = (payload && payload.userErrors) || [];
          if (errors.length) {
            throw new Error(errors.map(function (error) {
              return error.message;
            }).join('; '));
          }
          return getState(cartId);
        });
      })
      .then(function (verifiedCart) {
        if (!planIsSelected(verifiedCart, plan)) {
          throw new Error('Die Versandart konnte nicht verifiziert werden.');
        }
        if (!verifiedCart.checkoutUrl) {
          throw new Error('Checkout-URL fehlt.');
        }
        return {
          cartId: cartId,
          checkoutUrl: verifiedCart.checkoutUrl,
          selectedDeliveryOptions: plan
        };
      });
  }

  function selectWithOneFreshRetry(lieferart, options) {
    return selectOnce(lieferart, options).catch(function (firstError) {
      return selectOnce(lieferart, options).catch(function (secondError) {
        secondError.firstAttempt = firstError;
        throw secondError;
      });
    });
  }

  function ensure(lieferart, options) {
    var result = queue.then(function () {
      return selectWithOneFreshRetry(lieferart, options || {});
    });
    queue = result.catch(function () {});
    return result;
  }

  window.AcaiDeliverySync = {
    version: '1.0.0',
    ensure: ensure
  };
})();
